import React from 'react';
import TranslatableWysiwyg from '../TranslatableWysiwyg/TranslatableWysiwyg';

const TranslatableWysiwygField = ({
    input,
    original,
    withShortcodes,
    withColors,
    withImages,
    withTables,
    readOnly,
}) => {
    return (
        <TranslatableWysiwyg
            defaultValue={input?.value}
            onChange={input?.onChange}
            original={original}
            withShortcodes={withShortcodes}
            withColors={withColors}
            withImages={withImages}
            withTables={withTables}
            readOnly={readOnly}
        />
    );
};

export default TranslatableWysiwygField;
